/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Session } from '../entities/Session';
import { SessionManagerServiceRepositoryImpl } from '../impls/SessionManagerServiceRepositoryImpl';
import { ISessionManagerServiceRepository } from '../interfaces/ISessionManagerServiceRepository';
import { TCreateSessionParams } from '../types/TCreateSessionParams';
import { TServicesParams } from '../types/TServicesParams';
import { TSession, TSessionState } from '../types';

export class SessionManagerService implements ISessionManagerServiceRepository {
    TAG: string = 'SessionManagerService';

    private oSessionManagerRepositoryImpl: SessionManagerServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oSessionManagerRepositoryImpl = new SessionManagerServiceRepositoryImpl(params);
    }

    createSession(
        sessionParams: TCreateSessionParams,
        sessionNetworkCallId?: number,
    ): Promise<TSession> {
        return this.oSessionManagerRepositoryImpl.createSession(
            sessionParams,
            sessionNetworkCallId,
        );
    }

    sessionKeepAlive(session: Session, sessionNetworkCallId?: number): Promise<TSessionState> {
        return this.oSessionManagerRepositoryImpl.sessionKeepAlive(session, sessionNetworkCallId);
    }

    sessionDelete(session: Session, sessionNetworkCallId?: number): Promise<TSessionState> {
        return this.oSessionManagerRepositoryImpl.sessionDelete(session, sessionNetworkCallId);
    }
}
